import Axios from "axios"

export default {

  /**
   * 列表分页
   * @param {*} keyword 
   * @param {*} page 
   */
  listPage(
    keyword,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/externalStaff/listAllExternalStaffTag`, {
      params: {
        keyword,
        page
      }
    })
  },

  /**
   * 新增
   * @param {*} external_staff_tag_name 
   * @param {*} external_staff_tag_description 
   */
  add(
    external_staff_tag_name,
    external_staff_tag_description
  ) {
    return Axios.post(`${process.env.VUE_APP_PREFIX}/externalStaff/createExternalStaffTag`, {
      external_staff_tag_name,
      external_staff_tag_description
    });
  },

  /**
   * 编辑
   * @param {*} id 
   * @param {*} external_staff_tag_name 
   * @param {*} external_staff_tag_description 
   */
  edit(
    id,
    external_staff_tag_name,
    external_staff_tag_description
  ) {
    return Axios.post(`${process.env.VUE_APP_PREFIX}/externalStaff/saveExternalStaffTag/${id}`, {
      external_staff_tag_name,
      external_staff_tag_description
    });
  },

  /**
   * 删除
   * @param {*} id 
   */
  del(
    id
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/externalStaff/deleteExternalStaffTag/${id}`);
  },

  /**
   * 详情
   * @param {*} id 
   */
  info(
    id
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/externalStaff/getExternalStaffTag/${id}`);
  }

}